if (!customElements.get('rt-cart-shipping')) {
  customElements.define('rt-cart-shipping', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.country = this.form.elements.country;
      this.province = this.form.elements.province;
      this.results = this.querySelector('[data-results]');
      this.country.value = this.country.dataset.default;
      if (!this.country.value) this.country.selectedIndex = 0;
      this.updateProvinces();
      this.country.addEventListener('change', () => this.updateProvinces());
      this.form.addEventListener('input', () => { this.cancel(); this.results.replaceChildren(); });
      this.form.addEventListener('submit', (event) => { event.preventDefault(); this.calculate(); });
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => { this.cancel(); this.results.replaceChildren(); });
    }
    disconnectedCallback() { this.cancel(); this.unsubscribe?.(); }
    cancel() {
      this.controller?.abort();
      this.controller = null;
      this.form?.querySelector('button').removeAttribute('aria-busy');
    }
    updateProvinces() {
      const provinces = JSON.parse(this.country.selectedOptions[0]?.dataset.provinces || '[]');
      this.province.replaceChildren(...provinces.map(([value, label]) => new Option(label, value)));
      this.province.disabled = !provinces.length;
      this.querySelector('[data-province-wrap]').hidden = !provinces.length;
    }
    async calculate() {
      this.cancel();
      const controller = new AbortController();
      this.controller = controller;
      const signal = controller.signal;
      const timeout = setTimeout(() => controller.abort(), 20000);
      const button = this.form.querySelector('button');
      button.setAttribute('aria-busy', 'true');
      this.results.textContent = this.dataset.loading;
      const params = new URLSearchParams({ 'shipping_address[country]': this.country.value, 'shipping_address[province]': this.province.disabled ? '' : this.province.value, 'shipping_address[zip]': this.form.elements.zip.value.trim() });
      const request = async (name, method) => {
        const response = await fetch(`${this.dataset.cartUrl}/${name}.json?${params}`, { method, signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(this.dataset.error);
        return response.json();
      };
      try {
        await request('prepare_shipping_rates', 'POST');
        let data = null;
        for (let attempt = 0; attempt < 10; attempt++) {
          data = await request('async_shipping_rates', 'GET');
          if (data !== null) break;
          await new Promise((resolve, reject) => {
            const abort = () => { clearTimeout(timer); reject(new DOMException('Aborted', 'AbortError')); };
            const timer = setTimeout(() => { signal.removeEventListener('abort', abort); resolve(); }, 1000);
            signal.addEventListener('abort', abort, { once: true });
            if (signal.aborted) abort();
          });
        }
        if (!data || !Array.isArray(data.shipping_rates)) throw new Error(this.dataset.error);
        this.results.replaceChildren();
        if (!data.shipping_rates.length) this.results.textContent = this.dataset.empty;
        else {
          const list = document.createElement('ul');
          const formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, { style:'currency', currency:this.dataset.currency });
          data.shipping_rates.forEach((rate) => {
            const item = document.createElement('li');
            item.textContent = `${rate.name}: ${formatter.format(Number(rate.price))}`;
            list.append(item);
          });
          this.results.append(list);
        }
        const note = document.createElement('p');
        note.textContent = this.dataset.estimate;
        this.results.append(note);
      } catch (error) {
        if (this.controller === controller && this.isConnected) this.results.textContent = this.dataset.error;
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) button.removeAttribute('aria-busy');
      }
    }
  });
}
